import { App, Button, Dropdown, type MenuProps } from 'antd'
import { MdMoreVert } from 'react-icons/md'

import { cx } from '@/Ship/Helpers/cssClass'

import { TASK_TRANSITIONS } from '../Contracts/TaskTransitions'

import styles from './RequestFormTemplate.module.css'

/* eslint-disable no-unused-vars -- false positive: ESLint core rule flags param names in function-type signatures */
export interface TaskRowMenuActions {
    openCard: (task: any) => void
    /** Перегляд: перехід статусу, підтвердження, push */
    changeStatus?: ((task: any, status: string) => void) | undefined
    confirmExecution?: ((task: any) => void) | undefined
    sendPush?: ((task: any) => void) | undefined
    /** Редагування: видалення (після підтвердження) */
    deleteTask?: ((task: any) => void) | undefined
}

interface TaskRowMenuProps {
    task: any
    mode: 'view' | 'edit'
    /** Дії зі статусом/push доступні (`canManageTasks`) */
    canManage: boolean
    /** Видалення доступне для цього завдання (`canDeleteAssignment`) */
    canDelete: boolean
    busy?: boolean | undefined
    actions: TaskRowMenuActions
}

/** Меню «⋮» рядка завдання: відкрити картку, переходи статусу, підтвердити, push / видалити */
export const TaskRowMenu = ({ task, mode, canManage, canDelete, busy, actions }: TaskRowMenuProps) => {
    const { modal } = App.useApp()
    const status: string | undefined = task?.status
    const finished = status === 'completed_by_dispatcher'
    const items: MenuProps['items'] = [{ key: 'open', label: 'Відкрити картку' }]

    if (mode === 'view' && canManage && !finished) {
        const transitions = TASK_TRANSITIONS.filter((t) => t.from === status)
        if (transitions.length > 0) {
            items.push({ type: 'divider' })
            transitions.forEach((t) => items.push({ key: `status:${t.to}`, label: t.label }))
        }
        items.push({ type: 'divider' })
        items.push({
            key: 'confirm',
            label: status === 'completed_by_driver' ? 'Підтвердити виконання' : 'Підтвердити (примусово)',
        })
        items.push({ key: 'push', label: 'Push водієві' })
        if (task?.eWaybillNumber) items.push({ key: 'ettn', label: `е-ТТН ${task.eWaybillNumber}`, disabled: true })
    }

    if (mode === 'edit' && canDelete) {
        items.push({ type: 'divider' })
        items.push({ key: 'delete', label: 'Видалити', danger: true })
    }

    const onClick: MenuProps['onClick'] = ({ key }) => {
        if (key === 'open') return actions.openCard(task)
        if (key.startsWith('status:')) return actions.changeStatus?.(task, key.slice('status:'.length))
        if (key === 'confirm') return actions.confirmExecution?.(task)
        if (key === 'push') return actions.sendPush?.(task)
        if (key === 'delete') {
            modal.confirm({
                title: 'Видалити завдання?',
                content: task?.id ? `Завдання #${task.id} буде видалено без можливості відновлення.` : undefined,
                okText: 'Видалити',
                okButtonProps: { danger: true },
                cancelText: 'Скасувати',
                onOk: () => actions.deleteTask?.(task),
            })
        }
        return undefined
    }

    return (
        <Dropdown menu={{ items, onClick }} trigger={['click']} placement="bottomRight">
            <Button
                type="text"
                size="small"
                className={cx(styles, 'menuButton')}
                icon={<MdMoreVert size={18} />}
                loading={busy ?? false}
                aria-label={task?.id ? `Дії із завданням #${task.id}` : 'Дії із завданням'}
                onClick={(e) => e.stopPropagation()}
            />
        </Dropdown>
    )
}
